import Action from 'actions';
import BaseExecutor from 'services/sports/default/base-executor';
import CompetitionsNotBlankValidator from 'components/organisms/competition-stacking/validators/competitions-not-blank-validator';
import UniqueCompetitionValidator from 'components/organisms/competition-stacking/validators/unique-competition-validator';
import TotalExposureValidator from 'components/organisms/competition-stacking/validators/total-exposure-validator';
import OpponentExposureValidator from 'components/organisms/competition-stacking/validators/opponent-exposure-validator';
import BaseValidator from 'services/validations/base-validator';
import UserMessagesDictionary from 'components/organisms/competition-stacking/dictionaries/UserMessagesDictionary';

class FightStackingValidatorBuilder extends BaseExecutor {
    getInterface() {
        const {
            competitionStacking: stacking,
            playersData: {players},
            modesConfig,
        } = Action.getState();
        const competitionType = stacking.getCompetitionType();

        const validator = new BaseValidator();

        if (!stacking.isEnabled()) {
            return validator;
        }

        const competitionsNotBlankValidator = new CompetitionsNotBlankValidator();
        competitionsNotBlankValidator.setDependencies({
            stacking,
        });
        competitionsNotBlankValidator.setErrorMessage(
            UserMessagesDictionary.getCompetitionsNotBlankMessage(competitionType),
        );

        const uniqueCompetitionValidator = new UniqueCompetitionValidator();
        uniqueCompetitionValidator.setDependencies({
            stacking,
        });
        uniqueCompetitionValidator.setErrorMessage(
            UserMessagesDictionary.getUniqueCompetitionErrorMessage(competitionType),
        );

        const totalExposureValidator = new TotalExposureValidator();
        totalExposureValidator.setDependencies({
            stacking,
        });

        const opponentExposureValidator = new OpponentExposureValidator();
        opponentExposureValidator.setDependencies({
            stacking,
            players,
            modes: Object.keys(modesConfig.all()),
        });

        validator.addSubValidators([
            competitionsNotBlankValidator,
            uniqueCompetitionValidator,
            totalExposureValidator,
            opponentExposureValidator,
        ]);

        return validator;
    }
}

export {FightStackingValidatorBuilder};
